// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-speed-dial div.v-speed-dial__list {\n  align-items: baseline !important;\n}\n@media only screen and (min-width: 768px) {\n.v-speed-dial--bottom {\n    bottom: 14vh !important;\n}\n}\n@media only screen and (max-width: 767px) {\n.v-speed-dial--bottom {\n    bottom: 10vh !important;\n}\n}\n.helptext-style > span {\n  font-size: 80%;\n  padding-left: 2%;\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
